import { FormattedMessage } from 'react-intl';
import { Form, Input, Row, Col, FormInstance } from 'antd';
import {
  Group,
  GroupFormValues,
} from '@/core/domain/operational/Groups/Groups.types';
import FloatingFormItem from '@/components/_common/FloatingFormItem';
import {
  useDefaultEmptyFieldError,
  useDefaultMaxLengthFieldError,
} from '@/hooks';
import AreasInfiniteSelectField from '@/components/_common/AreasInfiniteSelectField';

interface GroupsGeneralFormProps {
  form: FormInstance<GroupFormValues>;
  group?: Group;
}

const GroupsGeneralForm = ({ form, group }: GroupsGeneralFormProps) => {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();
  const defaultMaxLenghtFieldError = useDefaultMaxLengthFieldError();

  return (
    <Form layout="vertical" form={form} name="groupGeneralForm">
      <Row gutter={[16, 16]}>
        <Col span={24} md={12}>
          <FloatingFormItem
            label={<FormattedMessage id="groups.general.form.description" />}
            name="name"
            rules={[defaultEmptyFieldError, defaultMaxLenghtFieldError(200)]}
          >
            <Input />
          </FloatingFormItem>
        </Col>
        <Col span={24} md={12}>
          <FloatingFormItem
            label={<FormattedMessage id="groups.general.form.area" />}
            name="subAreaId"
            rules={[defaultEmptyFieldError]}
          >
            <AreasInfiniteSelectField subAreaSelected={group?.subArea} />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default GroupsGeneralForm;
